module.exports = __webpack_public_path__ + "static/media/car-rental.c8f644e9.png";